// extracted by mini-css-extract-plugin
module.exports = {"contact":"contactsList_contact__1NK4l"};